function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.167 27.333V2.667c0-.511.2-.972.6-1.384.4-.41.866-.616 1.4-.616h22.666c.512 0 .973.205 1.384.616.41.412.616.873.616 1.384V20c0 .511-.205.972-.616 1.383-.411.412-.872.617-1.384.617H5.5L.167 27.333zm2-4.833l2.5-2.5h20.166V2.667H2.167V22.5zm0-19.833V22.5 2.667z",
  fill: "currentColor"
});
var SvgHelpChat = function SvgHelpChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27 28",
    fill: "none"
  }, props), _ref);
};
export default SvgHelpChat;